var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionIllustratedList',{attrs:{"id":"SectionOptimisedTraditional","items":_vm.items,"title":_vm.$t('title'),"videoSrc":"https://www.youtube.com/embed/zwtDwF_ZK9E"}})
}
var staticRenderFns = []

export { render, staticRenderFns }